export default {
  FETCH_RECEIPT_REPORT: 'FETCH_RECEIPT_REPORT',
  FETCH_RECEIPT_REPORT_SUCCESS: 'FETCH_RECEIPT_REPORT_SUCCESS',
  DOWNLOAD_RECEIPT_REPORT: 'DOWNLOAD_RECEIPT_REPORT'
}
